import { localStorageService } from '@/services/localStorage.service'

/**
 * Sidebar Status Management Service
 *
 * Manages the sidebar open/closed state using localStorage exclusively.
 */
const STORAGE_KEY = 'nopressure:sidebarStatus'

export const appSidebarStatus = {
  set(status: boolean): void {
    localStorageService.set(STORAGE_KEY, status)
  },

  get(): boolean {
    return localStorageService.get(STORAGE_KEY)
  },

  clear(): void {
    localStorageService.clear(STORAGE_KEY)
  },
}
